module.exports = "/_next/static/images/pencil-a769e2697c0758e24d491d0bf01479e5.svg";